var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('va-action-button',{attrs:{"icon":"mdi-play","label":"Commands","text":""},on:{"click":function($event){return _vm.showCommands(_vm.item)}}})}
var staticRenderFns = []

export { render, staticRenderFns }